import localforage from "localforage";
// @ts-ignore
import memoryDriver from "localforage-memoryStorageDriver";
import * as React from "react";

export const cache = async () => {
  // Register the custom `memoryDriver` to `localforage`
  await localforage.defineDriver(memoryDriver);

  // Create `localforage` instance
  const forageStore = localforage.createInstance({
    // List of drivers used
    driver: [
      localforage.INDEXEDDB,
      localforage.LOCALSTORAGE,
      memoryDriver._driver
    ],
    // Prefix all storage keys to prevent conflicts
    name: "mezze-ui"
  });

  return forageStore;
};

/**
 * useCache hook gives access to the cache to add and remove
 */
const useCache = () => {
  /**
   * removes and item form the cache pased on a string key
   *
   * @param key
   */
  const removeItemByKey = React.useCallback((key: string) => {
    cache().then(cache => {
      cache.removeItem(key);
    });
  }, []);

  /**
   * sets an item in the cache
   */
  const setItem = React.useCallback((key: string, value: string) => {
    cache().then(cache => {
      cache.setItem(key, value);
    });
  }, []);

  return {
    removeItemByKey,
    setItem
  };
};

export default useCache;
